import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "./Footer.jsx";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import "swiper/swiper-bundle.css";
//import promotion from "../../resources/img/promotions-241104.jpg";
import $ from "jquery";
import "../../resources/js/jquery.rwdImageMaps.js";

const StartProcess = () => {
	const swiperRef = useRef(null);
	const [position, setPosition] = useState(1065); // 초기 위치 1062px
	const [isMobile, setIsMobile] = useState(false); // 화면이 1250px 이하일 때 여부
	
  const location = useLocation();
  const navigate = useNavigate();

  const [presentationList, setPresentationList] = useState([]);
  const [sidoList, setSidoList] = useState([]);
  const [selectedSido, setSelectedSido] = useState("");
  const [activeIndex, setActiveIndex] = useState(null); // 활성화된 항목 인덱스 상태 추가

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 창업 절차`;

    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();
      if (result.redirect) {
        navigate(result.redirect);
      }
    };

    checkIP();

    const fetchSido = async () => {
      try {
        const response = await axios.get("/presentation");
        const result = response.data;
        const sido = [...new Set(result.map((item) => item.sido))];
        sido.sort((a, b) => a.localeCompare(b));
        setSidoList(sido);

        if (sido.length > 0) {
          setSelectedSido(sido[0]); // 첫 번째 sido를 기본 선택으로 설정
        }
      } catch (error) {
        console.error("Error fetching presentation list:", error);
      }
    };

    fetchSido();
	
	// DOM 렌더링 후 rwdImageMaps 초기화
	$("img[usemap]").rwdImageMaps();
  }, [location, navigate]);
  
  useEffect(() => {
    const handleResize = () => {
      // 화면 너비가 962px 이하일 때만 활성화
      if (window.innerWidth >= 1252) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    // 리사이즈 이벤트 리스너 추가
    window.addEventListener("resize", handleResize);

    // 초기 화면 크기 체크
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      const swiperWrapper = swiperRef.current?.swiper?.wrapperEl;

      // 처음 렌더링 시에도 위치를 설정 (1062px)
      if (swiperWrapper) {
        swiperWrapper.style.transform = `translate3d(${position}px, 0, 0)`;
      }

      const handleWheel = (event) => {
        // 마우스 휠 이벤트가 Swiper 영역에서만 반응하도록 처리
        if (swiperRef.current && swiperRef.current.swiper) {
          // Swiper 내부에서만 이벤트 처리
          const swiperContainer = swiperRef.current.swiper.el;
          if (swiperContainer.contains(event.target)) {
            let newPosition = position;

            // 마우스 휠 내릴 때, -1061px
            if (event.deltaY > 0) {
              newPosition -= 1061;
            } else if (event.deltaY < 0) {
              // 마우스 휠 올릴 때, +1601px
              newPosition += 1601;
            }

            // 새로운 위치가 1062px을 넘지 않도록 제한
            if (newPosition > 1065) {
              newPosition = 1065;
            }

            // 위치를 변환
            swiperWrapper.style.transform = `translate3d(${newPosition}px, 0, 0)`;

            // position state 업데이트
            setPosition(newPosition);
          }
        }
      };

      // 마우스 휠 이벤트 리스너 추가
      window.addEventListener("wheel", handleWheel, { passive: true });

      // Cleanup
      return () => {
        window.removeEventListener("wheel", handleWheel);
      };
    }
  }, [isMobile, position]); // 화면 크기와 position이 변경될 때마다 실행

  // fetchPresentation을 호출하여 선택된 sido의 발표를 가져오는 예시
  useEffect(() => {
    if (selectedSido) {
      fetchPresentation(selectedSido);
    }
  }, [selectedSido]);

  const fetchPresentation = async (sido) => {
    try {
      const response = await axios.get(
        `/presebo?sido=${encodeURIComponent(sido)}`
      );

      const uniquePresentations = Array.from(
        new Set(response.data.map((presentation) => presentation.gungu))
      ).map((gungu) => {
        return response.data.find(
          (presentation) => presentation.gungu === gungu
        );
      });

      // 오름차순으로 정렬 (예: gungu 기준)
      uniquePresentations.sort((a, b) => {
        if (a.gungu > b.gungu) return 1; // a가 b보다 크면 1 반환
        if (a.gungu < b.gungu) return -1; // a가 b보다 작으면 -1 반환
        return 0; // 같으면 0 반환
      });

      setPresentationList(uniquePresentations);
    } catch (error) {
      console.error("Error fetching presentations for selected sido:", error);
    }
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://dapi.kakao.com/v2/maps/sdk.js?appkey=d89224e6a469dfbd13e78b03285c57f8&autoload=false";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      const { kakao } = window;

      // kakao.maps.load를 사용하여 지도를 초기화합니다.
      kakao.maps.load(() => {
        presentationList.forEach((presentation, index) => {
          // 해당 index의 맵이 보일 때만
          const mapContainer = document.getElementById(`map${index}`);
          const mapOption = {
            center: new kakao.maps.LatLng(presentation.urlX, presentation.urlY), // 프랜차이즈의 GPS 좌표
            level: 3, // 지도의 확대 레벨
          };

          const map = new kakao.maps.Map(mapContainer, mapOption);

          // // 마커 추가
          const imageSrc = "../../custom-resources/images/map/marker_asobi.png",
            imageSize = new kakao.maps.Size(64, 69),
            imageOption = { offset: new kakao.maps.Point(27, 69) };

          const markerImage = new kakao.maps.MarkerImage(
            imageSrc,
            imageSize,
            imageOption
          );

          const markerPosition = new kakao.maps.LatLng(
            presentation.urlX,
            presentation.urlY
          );
          const marker = new kakao.maps.Marker({
            position: markerPosition,
            image: markerImage,
          });

          marker.setMap(map); // 마커를 지도에 표시
        });
      });
    };

    // 컴포넌트 언마운트 시 스크립트 제거
    return () => {
      document.head.removeChild(script);
    };
  }, [presentationList]);
  
  useEffect(() => {
    const handleResize = () => {
      const swiperElements = document.querySelectorAll(
        ".swiper-backface-hidden"
      );
      swiperElements.forEach((el) =>
        el.classList.remove("swiper-backface-hidden")
      );
    };

    // 초기 실행
    handleResize();

    // 리사이즈 이벤트 등록
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/startUp">아소비 창업</a>
              </li>
              <li>
                <a href="/startInfo">창업 안내</a>
              </li>
              <li>
                <a href="/startProcess" className="sel">
                  창업 절차
                </a>
              </li>
              <li>
                <a href="/benefit">지원 혜택</a>
              </li>
              <li>
                <a href="/asobimanager">아소비 지사장</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="subvisual">
          <div className="title"> 아소비 창업</div>
          <div className="text">
            꾸준히 늘어나는 가맹으로 증명하는 아소비 창업! <br />
            아소비에 대해 알아보고 당신도 성공하는 창업자가 되어 보세요.
          </div>
          <div className="image">
            <img
              src="../custom-resources/img/sub_startup_bg.png"
              alt=""
              className="pc-view"
            />
            <img
              src="../custom-resources/img/sub_startup_bg_mo.png"
              alt=""
              className="mo-view"
            />
          </div>
        </div>
        <div className="breadcrumb">
          <div className="wrap">
            <div className="loca">
              <span>
                <img src="../custom-resources/img/icon_home.png" alt="" />
              </span>
              <span className="on">아소비 창업</span>
            </div>
            <div className="menu">
              <a href="/startInfo">창업 안내</a>
              <a href="/startProcess" className="on">
                창업 절차
              </a>
              <a href="/benefit">지원 혜택</a>
              <a href="/asobimanager">아소비 지사장</a>
            </div>
          </div>
        </div>
        <div className="startProcess">
    {/* <div class="sect startProcess00">
		  <div class="img">
		    <img
		      src={promotion}
		      usemap="#main_map"
		      class="top_main_img"
		      alt=""
		    />
		    <map name="main_map">
		      <area
		        target="_blank"
		        alt="Asobi"
		        title="자세히 보기"
		        href="https://asobi24.gabia.io/"
		        coords="789,863,1144,960"
		        shape="rect"
		      />
		    </map>
		  </div>
		</div>*/}
          <div className="sect startProcess01">
            <div className="wrap">
              <div className="tit init">
                대한민국 5~9세 전문 교육원의 브랜드 파워!
              </div>
              <div className="txt init">
                본사는 적극적인 홍보와 아소비 개설까지 체계적인 시스템으로
                든든한 지원군이 되어 드립니다.
              </div>
              <div className="img init">
                <img
                  src="../custom-resources/img/img_startProcess_startProcess01_img.png"
                  alt=""
                />
              </div>
            </div>
          </div>
		  <div className="sect startProcess02">
		    <div className="wrap">
		      <div className="tit">아소비 개설 프로세스</div>
		      <div className="txt">
		        아소비 가맹 프로세스를 통해 누구보다 든든한 창업의 길을
		        열어드립니다. <br />
		        보다 자세한 사항은 본사 (1688-1993) 전화 또는 고객센터 상담
		        메뉴를 이용하셔서 확인하시기 바랍니다.
		      </div>
		    </div>
		    <div className="start2_scroll">
		      <div className="slider">
		        <Swiper
		          setWrapperSize={false}
		          centeredSlides={true}
		          roundLengths={true}
		          mousewheel={true} // Mousewheel 기능을 활성화
		          modules={[Mousewheel]} // Mousewheel 모듈을 활성화
		          breakpoints={{
		            320: {
		              spaceBetween: 1,
		              slidesPerView: 1,
		            },
		            1024: {
		              spaceBetween: 3,
		              slidesPerView: 3,
		            },
		          }} // 화면 크기에 따라 설정 변경
		          onSlideChange={() => {
		            setTimeout(() => {
		              console.log("Slide Changed");
		            }, 500);
		          }}
		          onReachEnd={() => {
		            setTimeout(() => {
		              console.log("Reached End");
		            }, 750);
		          }}
		          onSwiper={(swiper) => {
		            const removeBackfaceHidden = () => {
		              if (swiper && swiper.el) {
		                swiper.el.classList.remove("swiper-backface-hidden");
		              }
		            };

		            // 초기화 시 제거
		            removeBackfaceHidden();

		            // 리사이즈 이벤트
		            swiper.on("resize", removeBackfaceHidden);

		            // 브레이크포인트 변경 시
		            swiper.on("breakpoint", removeBackfaceHidden);

		            // 슬라이드 변경 시
		            swiper.on("slideChange", removeBackfaceHidden);

		            // Swiper 업데이트 시
		            swiper.on("update", removeBackfaceHidden);
		          }}
		        >
		          <SwiperSlide>
		            <em>01</em>
		            <i>
		              <img
		                src="../custom-resources/images/img_startProcess_startProcess02_img01.png"
		                alt="본사/지사 전화상담"
		              />
		            </i>
		            <span>본사/지사 전화상담</span>
		          </SwiperSlide>
		          <SwiperSlide>
		            <em>02</em>
		            <i>
		              <img
		                src="../custom-resources/images/img_startProcess_startProcess02_img02.png"
		                alt="대면상담"
		              />
		            </i>
		            <span>대면상담</span>
		          </SwiperSlide>
		          <SwiperSlide>
		            <em>03</em>
		            <i>
		              <img
		                src="../custom-resources/images/img_startProcess_startProcess02_img03.png"
		                alt="정보공개서/가맹계약서 인근가맹점 현황문서 수령"
		              />
		            </i>
		            <span>정보공개서/가맹계약서 인근가맹점 현황문서 수령</span>
		          </SwiperSlide>
		          <SwiperSlide>
		            <em>04</em>
		            <i>
		              <img
		                src="../custom-resources/images/img_startProcess_startProcess02_img04.png"
		                alt="가맹계약서 작성"
		              />
		            </i>
		            <span>가맹계약서 작성</span>
		          </SwiperSlide>
		          <SwiperSlide>
		            <em>05</em>
		            <i>
		              <img
		                src="../custom-resources/images/img_startProcess_startProcess02_img05.png"
		                alt="가맹예치금, 초도물품비 입금"
		              />
		            </i>
		            <span>
		              가맹예치금,
		              <br className="pc-view" />
		              초도물품비 입금
		            </span>
		          </SwiperSlide>
		          <SwiperSlide>
		            <em>06</em>
		            <i>
		              <img
		                src="../custom-resources/images/img_startProcess_startProcess02_img06.png"
		                alt="본사 및 지사 가맹 교육 수료"
		              />
		            </i>
		            <span>본사 및 지사 가맹 교육 수료</span>
		          </SwiperSlide>
		          <SwiperSlide>
		            <em>07</em>
		            <i>
		              <img
		                src="../custom-resources/images/img_startProcess_startProcess02_img07.png"
		                alt="참관수업 실시"
		              />
		            </i>
		            <span>참관수업 실시</span>
		          </SwiperSlide>
		          <SwiperSlide>
		            <em>08</em>
		            <i>
		              <img
		                src="../custom-resources/images/img_startProcess_startProcess02_img08.png"
		                alt="학부모 설명회 개최"
		              />
		            </i>
		            <span>학부모 설명회 개최</span>
		          </SwiperSlide>
		          <SwiperSlide>
		            <em>09</em>
		            <i>
		              <img
		                src="../custom-resources/images/img_startProcess_startProcess02_img09.png"
		                alt="개원"
		              />
		            </i>
		            <span>개원</span>
		          </SwiperSlide>
		        </Swiper>
		      </div>
		    </div>
		  </div>
          <div className="sect startProcess03" id="plist">
            <div className="wrap">
              <div className="tit init">이달의 아소비 창업설명회</div>
              <div className="txt init">
                학부모들이 인정하는 특화된 교육콘텐츠, 합리적이고 부담 없는 초기
                투자 비용으로 일과 삶 두 마리 토끼를 잡을 수 있는 사업! <br />
                이달의 아소비 창업설명회에 당신을 초대합니다.
              </div>
              <div className="txtB_area">
                <div className="txtB">* 창업 설명회 사전 예약 필수</div>
              </div>
              <div className="explain">
                <div className="step step01">
                  <div className="top">
                    <p>STEP01</p>
                    <span>지역선택</span>
                  </div>
                  <div className="button">
                    <ul>
                      {sidoList.map((sido, index) => (
                        <li key={index}>
                          <label className="radiobox">
                            <input
                              type="radio"
                              name="step"
                              value={sido}
                              checked={selectedSido === sido} // 선택된 sido에 따라 체크 상태 설정
                              onChange={() => setSelectedSido(sido)} // sido 변경 시 선택 상태 업데이트
                            />
                            <span>{sido}</span>
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="step step02">
                  <div className="top">
                    <p>STEP02</p>
                    <span>지역별 창업설명회</span>
                  </div>
                  <div className="list">
                    <ul className="hd">
                      <li>
                        <div className="desc">세부지역</div>
                        <div className="desc">장소</div>
                        <div className="desc">문의</div>
                      </li>
                    </ul>
                    <ul className="bd">
                      {presentationList.map((presentation, index) => (
                        <li
                          key={index}
                          className={activeIndex === index ? "on" : ""}
                          onClick={() => {
                            // 현재 activeIndex와 같은 인덱스를 클릭하면 닫기
                            setActiveIndex(
                              activeIndex === index ? null : index
                            );
                          }}
                        >
                          <div className="head">
                            <div className="desc">
                              <div className="zip">{presentation.gungu}</div>
                            </div>
                            <div className="desc">
                              <div className="addr">
                                <img
                                  src="../custom-resources/img/icon_place.png"
                                  alt=""
                                />
                                {presentation.place}
                              </div>
                            </div>
                            <div
                              className="desc"
                              onClick={(e) => e.stopPropagation()} //e.stopPropagation()을 호출함으로써 상위 요소로 전파되지 않음 고로 지도가 안보임
                            >
                              <div className="contact">
                                <span>
                                  <a href={`tel:${presentation.tel}`}>
                                    <img
                                      src="../custom-resources/img/icon_tele.png"
                                      alt=""
                                    />
                                    <p>{presentation.tel}</p>
                                  </a>
                                </span>
                                <span>
                                  <a href={presentation.kakao}>
                                    <img
                                      src="../custom-resources/img/icon_kakao.png"
                                      alt=""
                                    />
                                  </a>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`cont placeView ${
                              activeIndex === index ? "on" : ""
                            }`}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="placeBox">
                              <div className="head">아소비 창업설명회</div>
                              <div className="cont">
                                <div className="con">
                                  <div className="zip">
                                    {presentation.gungu}
                                  </div>
                                  <div className="tit">
                                    {presentation.place}
                                  </div>
                                  <div className="txt">
                                    <dl>
                                      <dt>
                                        <img
                                          src="../custom-resources/img/icon_telephone.png"
                                          alt=""
                                        />
                                      </dt>
                                      <dd>{presentation.tel}</dd>
                                    </dl>
                                  </div>
                                </div>
                                <div className="map" id={`map${index}`}></div>
                              </div>
                              <div
                                className="close"
                                onClick={(e) => {
                                  e.stopPropagation(); // 클릭 이벤트 전파 방지
                                  setActiveIndex(null); // 클로즈 클릭 시 activeIndex를 null로 설정
                                }}
                              >
                                <img
                                  src="../custom-resources/img/icon_placeClose.png"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default StartProcess;
